/**
 * @generated SignedSource<<12026b9c41950a590ff22f1b7969ae38>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedFiltersHelpers_shippingFilters$data = ReadonlyArray<{
  readonly totalCount: number | null;
  readonly " $fragmentType": "personalizedFiltersHelpers_shippingFilters";
}>;
export type personalizedFiltersHelpers_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: personalizedFiltersHelpers_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"personalizedFiltersHelpers_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "personalizedFiltersHelpers_shippingFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "4ce009729efa2bb5edc0685db84567ae";

export default node;
